export const AthenaSyncData = {
  matched: false,
  patients: [
    {
      contactpreference: 'MOBILEPHONE',
      contactpreference_announcement_email: false,
      contactpreference_announcement_phone: false,
      contactpreference_announcement_sms: false,
      contactpreference_appointment_email: false,
      contactpreference_appointment_phone: false,
      contactpreference_appointment_sms: false,
      contactpreference_billing_email: true,
      contactpreference_billing_phone: false,
      contactpreference_billing_sms: false,
      contactpreference_lab_email: true,
      contactpreference_lab_phone: false,
      contactpreference_lab_sms: false,
      departmentid: 2,
      dob: '02/15/1969',
      email: 'mohanapriya+69@intellihealthcorp.com',
      firstname: 'Priya',
      hasmobileyn: true,
      id: 69,
      lastname: 'Stguser69',
      primarydepartmentid: 2,
    },
  ],
};
